export default class ArticleNextObserver {
  constructor(rootBlock) {
    this.root = document.querySelector(rootBlock);
    this.next = this.root?.querySelector(".post-next_article");
    this.contactBtn = this.root?.querySelector(".js-sidebar-contact-btn");

    if (!this?.next && !this.contactBtn) return;

    this.lastItemFlag = false;
    this.observer = null;

    this.init();
  }

  init() {
    const lastItem = this.root?.querySelector(".contents-menu > li:last-child");
    if (!lastItem) return;

    const handleChange = () => {
      const isActive = lastItem.classList.contains("js-anchor-active");

      if (isActive) {
        this.onLastItemEnter();
      } else {
        this.onLastItemExit();
      }
    };

    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        if (m.attributeName === "class") {
          handleChange();
        }
      });
    });

    this.observer.observe(lastItem, {
      attributes: true,
      attributeFilter: ["class"],
    });

    handleChange();
  }

  onLastItemEnter() {
    if (this.lastItemFlag) return;
    this.lastItemFlag = true;
    if (this.next) this.root.classList.add("js-hide-menu");
    if (this.contactBtn) this.root.classList.add("js-hide-contact-btn");
  }

  onLastItemExit() {
    if (!this.lastItemFlag) return;
    this.lastItemFlag = false;
    if (this.next) this.root.classList.remove("js-hide-menu");
    if (this.contactBtn) this.root.classList.remove("js-hide-contact-btn");
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
